wbApp.controller('ClassroomsCtrl', ['$scope', '$modal', '$translate', 'classroomSvc', 'tenantSettingSvc',
function ($scope, $modal, $translate, classroomSvc, tenantSettingSvc) {

    function setSelectedClassroom(data) {
        $scope.selectedClassroom = data;
        $scope.$broadcast('classroomSelectionChanged', $scope.selectedClassroom);
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.classrooms = classroomSvc.getAllNonDeletedAsync(true);
        setSelectedEmployee(null);
    });

    $scope.classrooms = classroomSvc.getAllNonDeletedAsync(true);

    $scope.tabs = [
        {
            title: 'TXT_DETAIL',
            template: "setting/classrooms/detail-tabs/detail.html"
        }
    ];

    $scope.enableReservationSupport = tenantSettingSvc.settings.enableReservationSupport;
    $scope.enableRentSupport = tenantSettingSvc.settings.enableRentSupport;

    if ($scope.enableReservationSupport || $scope.enableRentSupport) {
        $scope.tabs.push({
            title: 'TXT_AVAILABILITY_SCHEDULE',
            template: 'setting/classrooms/detail-tabs/availability-schedule.html'
        })
    }

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

    $scope.gridSettings = {
        name: 'classrooms',
        columns: [
            { dataField: 'active', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '250px', sortOrder: 'asc' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string' },
            { dataField: 'showInCourses', caption: $translate.instant('TXT_LBL_COURSES'), dataType: 'boolean', width: '60px' },
            { dataField: 'showInReservations', caption: $translate.instant('TXT_LBL_RESERVATIONS'), dataType: 'boolean', width: '60px', visible: $scope.enableReservationSupport },
            { dataField: 'showInRents', caption: $translate.instant('TXT_MENU_RENTS'), dataType: 'boolean', width: '60px', visible: $scope.enableRentSupport },
            {
                dataField: 'addressID', caption: $translate.instant('TXT_LBL_ADDRESS'), dataType: 'boolean', width: '60px',
                calculateCellValue: function (rowData) {
                    return !!rowData.addressID;
                },
            }
        ]
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = classroomSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        classroomSvc.remove(data);
    }

    $scope.onRowSelected = function (data) {
        setSelectedClassroom(data);
    }

    
    var detailDialogPromise = $modal({
            templateUrl: 'setting/classrooms/classrooms-detail.html',
            show: false,
            scope: $scope.$new()
        });
    

}]);
